import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";

// CSS
import "@/styles/page/systemSettingProductPage.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import { workLocationManageTableColumn } from "@/config/tableColumnConfig";
import DataTable from "@/components/dataTable";

// Mui Icon
import DownloadIcon from "@mui/icons-material/Download";
import IconButton from "@mui/material/IconButton";
import { AddOutlined } from "@mui/icons-material";

//import generate csv library
import { CSVLink } from "react-csv";

// Fetch
import { getAllWorkLocationManage, getAllAdmin } from "@/fetch/fetchProduct";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";
import { useCurrentAction } from "@/hooks/user";

const WorkLocationManagePage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  // Navigate
  const navigate = useNavigate();

  // States
  const [workLocationData, setWorkLocationData] = React.useState([]);
  const [options, setOptions] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const onCellClick = (data) => {
    if (data.field === "__check__") return;
    else {
      navigate(`edit/${data.id}`, {
        state: {
          options: options,
        },
      });
    }
  };

  const onAddClick = () => {
    navigate("create/", {
      state: {
        options: options,
      },
    });
  };

  // create a headers for generate csv file
  const headers = [
    { label: "id", key: "id" },
    { label: "work_shortcode", key: "work_shortcode" },
    { label: "work_name", key: "work_name" },
    { label: "work_district", key: "work_district" },
    { label: "work_address", key: "work_address" },
    { label: "work_telephone", key: "work_telephone" },
    { label: "target_total_amount", key: "" },
    { label: "street", key: "street" },
    { label: "is_active", key: "" },
  ];

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getAllWorkLocationManage().then((data) => {
        if (data && data.results) {
          setWorkLocationData(data.data);
        } else {
          setWorkLocationData([]);
        }
      });
      await getAllAdmin().then((data) => {
        if (data && data.results) {
          setOptions(data.data);
        }
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      selectedIndex={16}
      header="workLocationManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title="店舖管理"
        history={() => navigate(-1)}
        children={
          <div>
            {/* Add Record */}
            {actions?.create && (
              <IconButton component="label" onClick={onAddClick}>
                <AddOutlined />
              </IconButton>
            )}
            {actions?.download && (
              <CSVLink
                data={workLocationData}
                filename={`Work Location List - ${moment(Date.startDate).format(
                  "YYYY-MM-DD"
                )} to ${moment(Date.endDate).format("YYYY-MM-DD")} `}
                headers={headers}
              >
                <IconButton component="label">
                  <DownloadIcon />
                </IconButton>
              </CSVLink>
            )}
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={workLocationData}
            onCellClick={(params) => onCellClick(params)}
            columns={workLocationManageTableColumn}
            pageSize={100}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default WorkLocationManagePage;
